export const START_REQUEST = "START_OPERATIONS_REQUEST";
export const GET_OPERATIONS = "GET_OPERATIONS";
export const END_REQUEST = "END_OPERATIONS_REQUEST";
//export const ADD_CARD = "ADD_CARD";
//export const EDIT_CARD = "EDIT_CARD";